import eventsService from '@/services/eventsService'
import router from '@/router'
import notifications from '@/libs/notifications'

const state = {
  // venues:
  venuesTags: [],
  // places:
  placeCategories: [],
  placePreferences: [],
  optionsPlacePreferences: {},
  searchPlacePreferences: '',
  categories: [],
  // events
  events: [],
  loadingEvents: true,
  paginationEvents: {},
  totalEvents: 0,
  types: [],
  eventCategories: [],
  eventPreferences: [],
  optionsEventPreferences: {},
  searchEventPreferences: '',
  // promotors
  optionsPromotors: {},
  totalPromotors: 0,
  promotors: [],
  loadingPromotors: false,
  methodNewEditPromotor: '', // could take 'new' or 'edit' values
  showNewEditPromotorDialog: false,
  newEditPromotorObj: {},
  loadingSubmitNewUpdatePromotor: false,
  // update promotor
  selectedPromotor: {},
  showSetPromotorProfilePhoto: false,
  uploadingPromotorProfilePhoto: false,
  showSetPromotorBannerPhoto: false,
  uploadingPromotorBannerPhoto: false,
  // dialog attach promotor url
  showAttachPromotorUrlDialog: false,
  // djs:
  searchDjs: '',
  optionsDjs: {},
  totalDjs: 0,
  djs: [],
  loadingDjs: false,
  methodNewViewEditDj: '', // 'new' || 'view' || 'edit'
  showNewViewEditDjDialog: false,
  newViewEditDjObj: {},
  loadingSubmitNewUpdateDj: false,
  // update dj photo
  showSetDjProfilePhoto: false,
  uploadingDjProfilePhoto: false,
  // dialog attach dj url
  showAttachDjUrlDialog: false,
  // products Categories
  searchProductsCategories: '',
  optionsProductsCategories: {},
  totalProductsCategories: 0,
  productsCategories: [],
  loadingProductsCategories: false,
  methodNewEditProductsCategory: '', // could take 'new' or 'edit' values
  showNewEditProductsCategoryDialog: false,
  newEditProductsCategoryObj: {},
  loadingSubmitNewUpdateProductsCategory: false,
  // update product
  selectedProductsCategory: {},
  showSetProductsCategoryPhoto: false,
  showSetProductsCategoryMiniaturePhoto: false,
  uploadingProductsCategoryPhoto: false,
  updateProductsCategoryObj: {},

  // products
  searchProducts: '',
  optionsProducts: {},
  totalProducts: 0,
  products: [],
  loadingProducts: false,
  methodNewEditProduct: '', // could take 'new' or 'edit' values
  showNewEditProductDialog: false,
  newEditProductObj: {},
  loadingSubmitNewUpdateProduct: false,
  // update product
  selectedProduct: {},
  showSetProductPhoto: false,
  showSetProductMiniaturePhoto: false,
  uploadingProductPhoto: false,
  updateProductObj: {},

  // places
  searchPlaces: '',
  optionsPlaces: {},
  totalPlaces: 0,
  places: [],
  loadingPlaces: false,
  methodNewEditPlace: '',
  showNewEditPlaceDialog: false,
  newEditPlaceObj: {},
  loadingSubmitNewUpdatePlace: false,
  // update place
  selectedPlace: {},
  showSetPlacePhoto: false,
  uploadingPlacePhoto: false,
  updatePlaceObj: {},
  // products purchases:
  searchPurchaseProducts: '',
  optionsPurchaseProducts: {},
  totalPurchaseProducts: 0,
  purchaseProducts: [],
  loadingPurchaseProducts: false,
  methodNewViewEditPurchaseProduct: '', // 'new' || 'view' || 'edit'
  showNewViewEditPurchaseProductDialog: false,
  selectedPurchaseProductObj: {}
}
const mutations = {
  // venues
  SET_VENUES_TAGS (state, venuesTags) {
    state.venuesTags = venuesTags
  },
  // places:
  SET_PLACE_CATEGORIES (state, categories) {
    state.placeCategories = categories
  },
  SET_PLACE_PREFERENCES (state, preferences) {
    state.placePreferences = preferences
  },
  SET_CATEGORIES (state, categories) {
    state.categories = categories
  },
  SET_SEARCH_PLACE_PREFERENCES (state, search) {
    state.searchPlacePreferences = search
  },
  SET_PAGINATION_PLACE_PREFERENCES (state, options) {
    state.optionsPlacePreferences = options
  },
  // events
  SET_EVENTS (state, events) {
    state.events = events
  },
  SET_LOADING_EVENTS (state, status) {
    state.loadingEvents = status
  },
  SET_PAGINATION_EVENTS (state, pagination) {
    state.paginationEvents = pagination
  },
  SET_TOTAL_EVENTS (state, totalEvents) {
    state.totalEvents = totalEvents
  },
  SET_EVENT_CATEGORIES (state, categories) {
    state.eventCategories = categories
  },
  SET_EVENT_PREFERENCES (state, preferences) {
    state.eventPreferences = preferences
  },
  SET_PAGINATION_EVENT_PREFERENCES (state, options) {
    state.optionsEventPreferences = options
  },
  SET_SEARCH_EVENT_PREFERENCES (state, search) {
    state.searchEventPreferences = search
  },
  SET_TYPES (state, types) {
    state.types = types
  },
  // promotors
  SET_PAGINATION_PROMOTORS (state, pagination) {
    state.optionsPromotors = pagination
  },
  SET_TOTAL_PROMOTORS (state, total) {
    state.totalPromotors = total
  },
  SET_PROMOTORS (state, promotors) {
    state.promotors = promotors
  },
  SET_LOADING_PROMOTORS (state, loading) {
    state.loadingPromotors = loading
  },
  SET_METHOD_CREATE_OR_UPDATE_PROMOTOR (state, type) {
    state.methodNewEditPromotor = type
  },
  SET_SHOW_NEW_EDIT_PROMOTOR_DIALOG (state, show) {
    state.showNewEditPromotorDialog = show
  },
  SET_NEW_EDIT_PROMOTOR_OBJ (state, newEditPromotorObj) {
    state.newEditPromotorObj = newEditPromotorObj
  },
  SET_LOADING_SUBMIT_NEW_EDIT_PROMOTOR (state, loading) {
    state.loadingSubmitNewUpdatePromotor = loading
  },
  SET_SELECTED_PROMOTOR (state, promotor) {
    state.selectedPromotor = promotor
  },
  SET_SHOW_SET_PROMOTOR_PROFILE_PHOTO (state, show) {
    state.showSetPromotorProfilePhoto = show
  },
  SET_UPLOADING_PROMOTOR_PROFILE_PHOTO (state, uploading) {
    state.uploadingPromotorProfilePhoto = uploading
  },
  SET_SHOW_SET_PROMOTOR_BANNER_PHOTO (state, show) {
    state.showSetPromotorBannerPhoto = show
  },
  SET_UPLOADING_PROMOTOR_BANNER_PHOTO (state, uploading) {
    state.uploadingPromotorBannerPhoto = uploading
  },
  SET_SHOW_ATTACH_PROMOTOR_URL_DIALOG (state, show) {
    state.showAttachPromotorUrlDialog = show
  },
  // djs
  SET_SEARCH_DJS (state, searchDjs) {
    state.searchDjs = searchDjs
  },
  SET_PAGINATION_DJS (state, pagination) {
    state.optionsDjs = pagination
  },
  SET_TOTAL_DJS (state, total) {
    state.totalDjs = total
  },
  SET_DJS (state, djs) {
    state.djs = djs
  },
  SET_LOADING_DJS (state, loading) {
    state.loadingDjs = loading
  },
  SET_METHOD_NEW_VIEW_EDIT_DJ (state, type) {
    state.methodNewViewEditDj = type
  },
  SET_SHOW_NEW_VIEW_EDIT_DJ_DIALOG (state, show) {
    state.showNewViewEditDjDialog = show
  },
  SET_NEW_VIEW_EDIT_DJ_OBJ (state, newViewEditDjObj) {
    state.newViewEditDjObj = newViewEditDjObj
  },
  SET_LOADING_SUBMIT_NEW_EDIT_DJ (state, loading) {
    state.loadingSubmitNewUpdateDj = loading
  },
  SET_SHOW_SET_DJ_PROFILE_PHOTO (state, show) {
    state.showSetDjProfilePhoto = show
  },
  SET_UPLOADING_DJ_PROFILE_PHOTO (state, uploading) {
    state.uploadingDjProfilePhoto = uploading
  },
  SET_SHOW_ATTACH_DJ_URL_DIALOG (state, show) {
    state.showAttachDjUrlDialog = show
  },
  // products Categories
  SET_SEARCH_PRODUCTS_CATEGORIES (state, searchProductsCategories) {
    state.searchProductsCategories = searchProductsCategories
  },
  SET_PAGINATION_PRODUCTS_CATEGORIES (state, pagination) {
    state.optionsProductsCategories = pagination
  },
  SET_TOTAL_PRODUCTS_CATEGORIES (state, total) {
    state.totalProductsCategories = total
  },
  SET_PRODUCTS_CATEGORIES (state, productsCategories) {
    state.productsCategories = productsCategories
  },
  SET_LOADING_PRODUCTS_CATEGORIES (state, loading) {
    state.loadingProductsCategories = loading
  },
  SET_METHOD_CREATE_OR_UPDATE_PRODUCTS_CATEGORY (state, type) {
    state.methodNewEditProductsCategory = type
  },
  SET_SHOW_NEW_EDIT_PRODUCTS_CATEGORY_DIALOG (state, show) {
    state.showNewEditProductsCategoryDialog = show
  },
  SET_NEW_EDIT_PRODUCTS_CATEGORY_OBJ (state, newEditProductsCategoryObj) {
    state.newEditProductsCategoryObj = newEditProductsCategoryObj
  },
  SET_LOADING_SUBMIT_NEW_EDIT_PRODUCTS_CATEGORY (state, loading) {
    state.loadingSubmitNewUpdateProductsCategory = loading
  },
  SET_SELECTED_PRODUCTS_CATEGORY (state, product) {
    state.selectedProductsCategory = product
  },
  SET_SHOW_SET_PRODUCTS_CATEGORY_PHOTO (state, show) {
    state.showSetProductsCategoryPhoto = show
  },
  SET_SHOW_SET_PRODUCTS_CATEGORY_MINIATURE_PHOTO (state, show) {
    state.showSetProductsCategoryMiniaturePhoto = show
  },
  SET_UPLOADING_PRODUCTS_CATEGORY_PHOTO (state, uploading) {
    state.uploadingProductsCategoryPhoto = uploading
  },
  // products
  SET_SEARCH_PRODUCTS (state, searchProducts) {
    state.searchProducts = searchProducts
  },
  SET_PAGINATION_PRODUCTS (state, pagination) {
    state.optionsProducts = pagination
  },
  SET_TOTAL_PRODUCTS (state, total) {
    state.totalProducts = total
  },
  SET_PRODUCTS (state, products) {
    state.products = products
  },
  SET_LOADING_PRODUCTS (state, loading) {
    state.loadingProducts = loading
  },
  SET_METHOD_CREATE_OR_UPDATE_PRODUCT (state, type) {
    state.methodNewEditProduct = type
  },
  SET_SHOW_NEW_EDIT_PRODUCT_DIALOG (state, show) {
    state.showNewEditProductDialog = show
  },
  SET_NEW_EDIT_PRODUCT_OBJ (state, newEditProductObj) {
    state.newEditProductObj = newEditProductObj
  },
  SET_LOADING_SUBMIT_NEW_EDIT_PRODUCT (state, loading) {
    state.loadingSubmitNewUpdateProduct = loading
  },
  SET_SELECTED_PRODUCT (state, product) {
    state.selectedProduct = product
  },
  SET_SHOW_SET_PRODUCT_PHOTO (state, show) {
    state.showSetProductPhoto = show
  },
  SET_SHOW_SET_PRODUCT_MINIATURE_PHOTO (state, show) {
    state.showSetProductMiniaturePhoto = show
  },
  SET_UPLOADING_PRODUCT_PHOTO (state, uploading) {
    state.uploadingProductPhoto = uploading
  },
  // places
  SET_SEARCH_PLACES (state, searchPlaces) {
    state.searchPlaces = searchPlaces
  },
  SET_PAGINATION_PLACES (state, pagination) {
    state.optionsPlaces = pagination
  },
  SET_TOTAL_PLACES (state, total) {
    state.totalPlaces = total
  },
  SET_PLACES (state, places) {
    state.places = places
  },
  SET_LOADING_PLACES (state, loading) {
    state.loadingPlaces = loading
  },
  SET_METHOD_CREATE_OR_UPDATE_PLACE (state, type) {
    state.methodNewEditPlace = type
  },
  SET_SHOW_NEW_EDIT_PLACE_DIALOG (state, show) {
    state.showNewEditPlaceDialog = show
  },
  SET_NEW_EDIT_PLACE_OBJ (state, newEditPlaceObj) {
    state.newEditPlaceObj = newEditPlaceObj
  },
  SET_LOADING_SUBMIT_NEW_EDIT_PLACE (state, loading) {
    state.loadingSubmitNewUpdatePlace = loading
  },
  SET_SELECTED_PLACE (state, promotor) {
    state.selectedPlace = promotor
  },
  SET_SHOW_SET_PLACE_PHOTO (state, show) {
    state.showSetPlacePhoto = show
  },
  SET_UPLOADING_PLACE_PHOTO (state, uploading) {
    state.uploadingPlacePhoto = uploading
  },
  // products purchases
  SET_SEARCH_PURCHASE_PRODUCTS (state, searchPurchaseProducts) {
    state.searchPurchaseProducts = searchPurchaseProducts
  },
  SET_PAGINATION_PURCHASE_PRODUCTS (state, pagination) {
    state.optionsPurchaseProducts = pagination
  },
  SET_TOTAL_PURCHASE_PRODUCTS (state, total) {
    state.totalPurchaseProducts = total
  },
  SET_PURCHASE_PRODUCTS (state, purchaseProducts) {
    state.purchaseProducts = purchaseProducts
  },
  SET_LOADING_PURCHASE_PRODUCTS (state, loading) {
    state.loadingPurchaseProducts = loading
  },
  SET_METHOD_NEW_VIEW_EDIT_PURCHASE_PRODUCT (state, type) {
    state.methodNewViewEditPurchaseProduct = type
  },
  SET_SHOW_NEW_VIEW_EDIT_PURCHASE_PRODUCT_DIALOG (state, show) {
    state.showNewViewEditPurchaseProductDialog = show
  },
  SET_SELECTED_PURCHASE_PRODUCT (state, product) {
    state.selectedPurchaseProductObj = product
  }
}

const actions = {
  // venues:
  getVenuesTags (vuexContext) {
    eventsService
      .getVenuesTags(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        {}
      )
      .then(response => {
        if (response.tags && response.tags.rows &&
        Array.isArray(response.tags.rows) && response.tags.rows.length &&
        response.tags.rows[0].tags) {
          vuexContext.commit('SET_VENUES_TAGS', response.tags.rows[0].tags)
        }
      })
      .catch(() => {
        vuexContext.commit('SET_VENUES_TAGS', [])
      })
  },
  updateVenuesTags (vuexContext) {
    eventsService
      .updateVenuesTags(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.venuesTags
      )
  },
  createPlaceCategories (vuexContext, category) {
    return eventsService.createPlaceCategories(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      category)
  },

  updatePlaceCategory (vuexContext, { category, categoryId }) {
    return eventsService.updatePlaceCategory(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      category,
      categoryId)
  },
  getPlaceCategories (vuexContext) {
    eventsService
      .getPlaceCategories(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid
      )
      .then(({ data }) => {
        const categories = data.placesCategories.rows
        vuexContext.commit('SET_PLACE_CATEGORIES', categories)
      })
      .catch(error => {
        console.error(error)
      })
  },
  createEventPreferences (vuexContext, preference) {
    return eventsService.createEventPreferences(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      preference)
  },

  updateEventPreference (vuexContext, { preference, preferenceId }) {
    return eventsService.updateEventPreference(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      preference,
      preferenceId)
  },

  updatePlacePreference (vuexContext, { preference, preferenceId }) {
    return eventsService.updatePlacePreference(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      preference,
      preferenceId)
  },

  createPlacePreferences (vuexContext, preference) {
    return eventsService.createPlacePreferences(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      preference)
  },
  getPlacePreferences (vuexContext) {
    eventsService
      .getPlacePreferences(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.optionsPlacePreferences,
        vuexContext.state.searchPlacePreferences
      )
      .then(({ data }) => {
        const preferences = data.placesPreferences.rows
        vuexContext.commit('SET_PLACE_PREFERENCES', preferences)
      })
      .catch(error => {
        console.error(error)
      })
  },
  createEventCategories (vuexContext, category) {
    return eventsService.createEventCategories(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      category)
  },

  updateEventCategory (vuexContext, { category, categoryId }) {
    console.log(categoryId)
    return eventsService.updateEventCategory(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      category,
      categoryId)
  },
  getEventCategories (vuexContext) {
    eventsService
      .getEventCategories(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid
      )
      .then(({ data }) => {
        const categories = data.eventsCategories.rows
        vuexContext.commit('SET_EVENT_CATEGORIES', categories)
      })
      .catch(error => {
        console.error(error)
      })
  },
  getEventPreferences (vuexContext) {
    eventsService
      .getEventPreferences(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.optionsEventPreferences,
        vuexContext.state.searchEventPreferences
      )
      .then(({ data }) => {
        const preferences = data.eventsPreferences.rows
        vuexContext.commit('SET_EVENT_PREFERENCES', preferences)
      })
      .catch(error => {
        console.error(error)
      })
  },
  createEvent (vuexContext, data) {
    return new Promise((resolve, reject) => {
      eventsService
        .createEvent(
          vuexContext.getters.token,
          vuexContext.getters.companyUuid,
          vuexContext.getters.appUuid,
          data
        )
        .then(() => {
          vuexContext.dispatch('getEvents')
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getEvent (vuexContext, { companyId, appId, eventId }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      eventsService
        .getEvent(vuexContext.getters.token, company, app, eventId)
        .then(response => {
          if (response.event) {
            resolve(response.event)
          } else {
            reject(new Error('Error cargando el evento'))
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getEvents (vuexContext) {
    eventsService
      .getEvents(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.paginationEvents
      )
      .then(response => {
        vuexContext.commit('SET_TOTAL_EVENTS', response.events.count)
        vuexContext.commit('SET_EVENTS', response.events.rows)
        vuexContext.commit('SET_LOADING_EVENTS', false)
      })
      .catch(() => {
        vuexContext.commit('SET_TOTAL_EVENTS', 0)
        vuexContext.commit('SET_EVENTS', [])
        vuexContext.commit('SET_LOADING_EVENTS', false)
      })
  },
  /*
  getEventsCategories (vuexContext) {
    eventsService.getCategories().then(response => {
      vuexContext.commit('SET_CATEGORIES', response.categories)
    })
  },
  getEventsTypes (vuexContext) {
    eventsService.getTypes().then(response => {
      vuexContext.commit('SET_TYPES', response.types)
    })
  },
  */
  async importAttendees (vuexContext, { eventId, ticketId, file }) {
    return await eventsService.importAttendees(
      vuexContext.getters.token,
      vuexContext.getters.companyUuid,
      vuexContext.getters.appUuid,
      { eventId, ticketId, file }
    )
  },
  updateEvent (vuexContext, data) {
    return new Promise((resolve, reject) => {
      eventsService
        .updateEvent(
          vuexContext.getters.token,
          vuexContext.getters.companyUuid,
          vuexContext.getters.appUuid,
          data.eventId,
          data
        )
        .then(() => {
          vuexContext.dispatch('getEvents')
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  async deleteEvent (vuexContext, eventId) {
    const company = vuexContext.getters.companyUuid
    const app = vuexContext.getters.appUuid
    const response = await eventsService.deleteEvent(
      vuexContext.getters.token,
      company,
      app,
      eventId
    )
    return response
  },

  // promotors:
  getPromotors (vuexContext) {
    vuexContext.commit('SET_LOADING_PROMOTORS', true)
    eventsService
      .getPromotors(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid || router.currentRoute.params.appid,
        vuexContext.state.optionsPromotors
      )
      .then(response => {
        vuexContext.commit('SET_TOTAL_PROMOTORS', response.promotors.count)
        vuexContext.commit('SET_PROMOTORS', response.promotors.rows)
        vuexContext.commit('SET_LOADING_PROMOTORS', false)
      })
      .catch(() => {
        vuexContext.commit('SET_TOTAL_PROMOTORS', 0)
        vuexContext.commit('SET_PROMOTORS', [])
        vuexContext.commit('SET_LOADING_PROMOTORS', false)
      })
  },
  async createPromotor (vuexContext) {
    try {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PROMOTOR', true)
      const newPromotor = {
        status: vuexContext.state.newEditPromotorObj.status,
        ranking: vuexContext.state.newEditPromotorObj.ranking,
        location: vuexContext.state.newEditPromotorObj.location,
        locationUrl: vuexContext.state.newEditPromotorObj.locationUrl,
        fbSendMessageUrl: vuexContext.state.newEditPromotorObj.fbSendMessageUrl,
        fbProfileUrl: vuexContext.state.newEditPromotorObj.fbProfileUrl,
        // webUrl: vuexContext.state.newEditPromotorObj.webUrl,
        rawHtml: vuexContext.state.newEditPromotorObj.rawHtml
      }
      if (vuexContext.state.newEditPromotorObj.userId) {
        Object.assign(newPromotor, {
          userId: vuexContext.state.newEditPromotorObj.userId
        })
      } else {
        Object.assign(newPromotor, {
          email: vuexContext.state.newEditPromotorObj.email,
          name: vuexContext.state.newEditPromotorObj.name,
          password: vuexContext.state.newEditPromotorObj.password,
          phone: vuexContext.state.newEditPromotorObj.phone,
          country: vuexContext.state.newEditPromotorObj.country,
          countryCode: vuexContext.state.newEditPromotorObj.countryCode
        })
      }
      const response = await eventsService.createPromotor(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        newPromotor
      )
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PROMOTOR', false)
      if (response && response.errors) {
        for (let i = 0; i < response.errors.length; i++) {
          await notifications.error(response.errors[i].msg)
        }
      }
      if (response && response.warnings) {
        for (let i = 0; i < response.warnings.length; i++) {
          await notifications.info(response.warnings[i].msg)
        }
      }
      if (response && response.success) {
        await vuexContext.dispatch('getPromotors')
        // open modal to uplaod profile photo
        vuexContext.commit('SET_SHOW_SET_PROMOTOR_PROFILE_PHOTO', true)
        return response
      }
      return false
    } catch (error) {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PROMOTOR', false)
      throw error
    }
  },
  async updatePromotor (vuexContext) {
    try {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PROMOTOR', true)
      const updatePromotorObj = {
        userId: vuexContext.state.newEditPromotorObj.userId,
        status: vuexContext.state.newEditPromotorObj.status,
        ranking: vuexContext.state.newEditPromotorObj.ranking,
        location: vuexContext.state.newEditPromotorObj.location,
        locationUrl: vuexContext.state.newEditPromotorObj.locationUrl,
        fbSendMessageUrl: vuexContext.state.newEditPromotorObj.fbSendMessageUrl,
        fbProfileUrl: vuexContext.state.newEditPromotorObj.fbProfileUrl,
        // webUrl: vuexContext.state.newEditPromotorObj.webUrl,
        rawHtml: vuexContext.state.newEditPromotorObj.rawHtml
      }
      const promotorId = vuexContext.state.newEditPromotorObj.id
      const response = await eventsService.updatePromotor(
        vuexContext.getters.token,
        promotorId,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        updatePromotorObj
      )
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PROMOTOR', false)
      if (response && response.errors) {
        for (let i = 0; i < response.errors.length; i++) {
          await notifications.error(response.errors[i].msg)
        }
      }
      if (response && response.warnings) {
        for (let i = 0; i < response.warnings.length; i++) {
          await notifications.info(response.warnings[i].msg)
        }
      }
      if (response && response.success) {
        await vuexContext.dispatch('getPromotors')
        return response
      }
      return false
    } catch (error) {
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PROMOTOR', false)
      throw error
    }
  },
  // upload promotor's profile photo
  async uploadPromotorProfilePhoto (vuexContext, { filesForm }) {
    try {
      await vuexContext.commit('SET_UPLOADING_PROMOTOR_PROFILE_PHOTO', true)
      const response = await eventsService.uploadPromotorProfilePhoto(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.selectedPromotor.userId,
        { filesForm }
      )
      vuexContext.commit('SET_UPLOADING_PROMOTOR_PROFILE_PHOTO', false)
      if (response.success) {
        vuexContext.commit('SET_SHOW_SET_PROMOTOR_PROFILE_PHOTO', false)
        notifications.success('La foto de perfil del promotor fue actualizada')
      } else {
        notifications.error(
          'Sucedió un error al subir foto de perfil del promotor'
        )
      }
    } catch (error) {
      vuexContext.commit('SET_UPLOADING_PROMOTOR_PROFILE_PHOTO', false)
    }
  },
  // upload promotor's banner photo
  async uploadPromotorBannerPhoto (vuexContext, { filesForm }) {
    try {
      await vuexContext.commit('SET_UPLOADING_PROMOTOR_BANNER_PHOTO', true)
      const response = await eventsService.uploadPromotorBannerPhoto(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.selectedPromotor.userId,
        { filesForm }
      )
      vuexContext.commit('SET_UPLOADING_PROMOTOR_BANNER_PHOTO', false)
      if (response.success) {
        vuexContext.commit('SET_SHOW_SET_PROMOTOR_BANNER_PHOTO', false)
        notifications.success('El banner del promotor fue actualizado')
      } else {
        notifications.error('Sucedió un error al subir el banner del promotor')
      }
    } catch (error) {
      vuexContext.commit('SET_UPLOADING_PROMOTOR_BANNER_PHOTO', false)
    }
  },
  async deletePromotor (vuexContext) {
    const company = vuexContext.getters.companyUuid
    const app = vuexContext.getters.appUuid
    const promotorId = vuexContext.state.selectedPromotor.userId
    const response = await eventsService.deletePromotor(
      vuexContext.getters.token,
      company,
      app,
      promotorId
    )
    return response
  },
  // djs:
  getDjs (vuexContext) {
    vuexContext.commit('SET_LOADING_DJS', true)
    const company = vuexContext.getters.companyUuid
    if (!company) {
      return console.log('No company was selected')
    }
    eventsService
      .getDjs(
        vuexContext.getters.token,
        company,
        vuexContext.getters.appUuid || router.currentRoute.params.appid,
        vuexContext.state.optionsDjs,
        vuexContext.state.searchDjs
      )
      .then(response => {
        vuexContext.commit('SET_TOTAL_DJS', response.djs.count)
        vuexContext.commit('SET_DJS', response.djs.rows)
        vuexContext.commit('SET_LOADING_DJS', false)
      })
      .catch(() => {
        vuexContext.commit('SET_TOTAL_DJS', 0)
        vuexContext.commit('SET_DJS', [])
        vuexContext.commit('SET_LOADING_DJS', false)
      })
  },
  async createDj (vuexContext) {
    try {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_DJ', true)
      const newDj = {
        status: vuexContext.state.newViewEditDjObj.status,
        followers: vuexContext.state.newViewEditDjObj.followers,
        location: vuexContext.state.newViewEditDjObj.location,
        locationUrl: vuexContext.state.newViewEditDjObj.locationUrl,
        rawHtml: vuexContext.state.newViewEditDjObj.rawHtml
      }
      if (vuexContext.state.newViewEditDjObj.userId) {
        Object.assign(newDj, {
          userId: vuexContext.state.newViewEditDjObj.userId
        })
      } else {
        Object.assign(newDj, {
          email: vuexContext.state.newViewEditDjObj.email,
          name: vuexContext.state.newViewEditDjObj.name,
          password: vuexContext.state.newViewEditDjObj.password,
          phone: vuexContext.state.newViewEditDjObj.phone,
          country: vuexContext.state.newViewEditDjObj.country,
          countryCode: vuexContext.state.newViewEditDjObj.countryCode
        })
      }
      const response = await eventsService.createDj(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        newDj
      )
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_DJ', false)
      if (response && response.warnings) {
        for (let i = 0; i < response.warnings.length; i++) {
          await notifications.info(response.warnings[i].msg)
        }
      }
      if (response && response.success) {
        await vuexContext.dispatch('getDjs')
        // open modal to uplaod profile photo
        vuexContext.commit('SET_SHOW_SET_DJ_PROFILE_PHOTO', true)
        return response
      }
      return false
    } catch (error) {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_DJ', false)
      throw error
    }
  },
  async updateDj (vuexContext) {
    try {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_DJ', true)
      const updateDjObj = {
        userId: vuexContext.state.newViewEditDjObj.userId,
        status: vuexContext.state.newViewEditDjObj.status,
        followers: vuexContext.state.newViewEditDjObj.followers,
        location: vuexContext.state.newViewEditDjObj.location,
        locationUrl: vuexContext.state.newViewEditDjObj.locationUrl,
        rawHtml: vuexContext.state.newViewEditDjObj.rawHtml
      }
      const djId = vuexContext.state.newViewEditDjObj.id
      const response = await eventsService.updateDj(
        vuexContext.getters.token,
        djId,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        updateDjObj
      )
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_DJ', false)
      if (response && response.errors) {
        for (let i = 0; i < response.errors.length; i++) {
          await notifications.error(response.errors[i].msg)
        }
      }
      if (response && response.warnings) {
        for (let i = 0; i < response.warnings.length; i++) {
          await notifications.info(response.warnings[i].msg)
        }
      }
      if (response && response.success) {
        await vuexContext.dispatch('getDjs')
        return response
      }
      return false
    } catch (error) {
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_DJ', false)
      throw error
    }
  },
  // upload dj's profile photo
  async uploadDjProfilePhoto (vuexContext, { filesForm }) {
    try {
      await vuexContext.commit('SET_UPLOADING_DJ_PROFILE_PHOTO', true)
      const response = await eventsService.uploadDjProfilePhoto(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.newViewEditDjObj.userId,
        { filesForm }
      )
      vuexContext.commit('SET_UPLOADING_DJ_PROFILE_PHOTO', false)
      if (response.success) {
        vuexContext.commit('SET_SHOW_SET_DJ_PROFILE_PHOTO', false)
        notifications.success('La foto de perfil del dj fue actualizada')
      } else {
        notifications.error('Sucedió un error al subir foto de perfil del dj')
      }
    } catch (error) {
      vuexContext.commit('SET_UPLOADING_DJ_PROFILE_PHOTO', false)
    }
  },
  async deleteDj (vuexContext) {
    const company = vuexContext.getters.companyUuid
    const app = vuexContext.getters.appUuid
    const djId = vuexContext.state.newViewEditDjObj.userId
    const response = await eventsService.deleteDj(
      vuexContext.getters.token,
      company,
      app,
      djId
    )
    return response
  },

  // PLACES
  getPlaces (vuexContext) {
    const company = vuexContext.getters.companyUuid
    if (!company) {
      return console.log('No company was selected')
    }

    vuexContext.commit('SET_LOADING_PLACES', true)

    eventsService
      .getPlaces(
        vuexContext.getters.token,
        company,
        vuexContext.getters.appUuid || router.currentRoute.params.appid,
        vuexContext.state.optionsPlaces,
        vuexContext.state.searchPlaces
      )
      .then(response => {
        vuexContext.commit('SET_TOTAL_PLACES', response.places.count)
        vuexContext.commit('SET_PLACES', response.places.rows)
        vuexContext.commit('SET_LOADING_PLACES', false)
      })
      .catch(() => {
        vuexContext.commit('SET_TOTAL_PLACES', 0)
        vuexContext.commit('SET_PLACES', [])
        vuexContext.commit('SET_LOADING_PLACES', false)
      })
  },

  async createPlace (vuexContext, duplicates) {
    const place = vuexContext.state.newEditPlaceObj
    try {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PLACE', true)
      const response = await eventsService.createPlace(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        duplicates,
        place
      )
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PLACE', false)
      if (response && response.success && response.place) {
        await vuexContext.dispatch('getPlaces')
        return response
      }
      return false
    } catch (error) {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PLACE', false)
      throw error
    }
  },

  async updatePlace (vuexContext) {
    try {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PLACE', true)
      const updatePlaceObj = {
        name: vuexContext.state.newEditPlaceObj.name,
        type: vuexContext.state.newEditPlaceObj.type,
        description: vuexContext.state.newEditPlaceObj.description,
        phone: vuexContext.state.newEditPlaceObj.phone,
        email: vuexContext.state.newEditPlaceObj.email,
        website: vuexContext.state.newEditPlaceObj.website,
        placeLocation: vuexContext.state.newEditPlaceObj.placeLocation,
        placeLocationUrl: vuexContext.state.newEditPlaceObj.placeLocationUrl,
        placeLocationReference: vuexContext.state.newEditPlaceObj.placeLocationReference,
        coverImage: vuexContext.state.newEditPlaceObj.coverImage,
        images: vuexContext.state.newEditPlaceObj.images,
        socialLinks: vuexContext.state.newEditPlaceObj.socialLinks,
        contacts: vuexContext.state.newEditPlaceObj.contacts,
        active: vuexContext.state.newEditPlaceObj.active,
        city: vuexContext.state.newEditPlaceObj.city,
        state: vuexContext.state.newEditPlaceObj.state,
        country: vuexContext.state.newEditPlaceObj.country,
        zipcode: vuexContext.state.newEditPlaceObj.zipcode,
        categories: vuexContext.state.newEditPlaceObj.categories,
        preferences: vuexContext.state.newEditPlaceObj.preferences,
        experiences: vuexContext.state.newEditPlaceObj.experiences,
        offerings: vuexContext.state.newEditPlaceObj.offerings,
        placeRating: vuexContext.state.newEditPlaceObj.placeRating,
        priceRating: vuexContext.state.newEditPlaceObj.priceRating,
        tags: vuexContext.state.newEditPlaceObj.tags,
        isRestaurant: vuexContext.state.newEditPlaceObj.isRestaurant,
        diningStyle: vuexContext.state.newEditPlaceObj.diningStyle,
        dressCode: vuexContext.state.newEditPlaceObj.dressCode,
        acceptedPaymentMethods: vuexContext.state.newEditPlaceObj.acceptedPaymentMethods,
        parkingType: vuexContext.state.newEditPlaceObj.parkingType,
        priceAverage: vuexContext.state.newEditPlaceObj.priceAverage,
        brunchSchedules: vuexContext.state.newEditPlaceObj.brunchSchedules,
        lunchSchedules: vuexContext.state.newEditPlaceObj.lunchSchedules,
        happyHourSchedules: vuexContext.state.newEditPlaceObj.happyHourSchedules,
        dinnerSchedules: vuexContext.state.newEditPlaceObj.dinnerSchedules,
        timeZone: vuexContext.state.newEditPlaceObj.timeZone,
        currency: vuexContext.state.newEditPlaceObj.currency,
        workingHours: vuexContext.state.newEditPlaceObj.workingHours
      }
      const placeId = vuexContext.state.newEditPlaceObj.id

      const response = await eventsService.updatePlace(
        vuexContext.getters.token,
        placeId,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        updatePlaceObj
      )
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PLACE', false)
      if (response && response.errors) {
        for (let i = 0; i < response.errors.length; i++) {
          await notifications.error(response.errors[i].msg)
        }
      }
      if (response && response.warnings) {
        for (let i = 0; i < response.warnings.length; i++) {
          await notifications.info(response.warnings[i].msg)
        }
      }
      if (response && response.success) {
        await vuexContext.dispatch('getPlaces')
        return response
      }
      return false
    } catch (error) {
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PLACE', false)
      throw error
    }
  },

  async deletePlace (vuexContext) {
    const company = vuexContext.getters.companyUuid
    const app = vuexContext.getters.appUuid
    const placeId = vuexContext.state.selectedPlace.id
    const response = await eventsService.deletePlace(
      vuexContext.getters.token,
      company,
      app,
      placeId
    )
    return response
  },
  // products categories:
  getProductsCategories (vuexContext) {
    const company = vuexContext.getters.companyUuid
    if (!company) {
      return console.log('No company was selected')
    }
    vuexContext.commit('SET_LOADING_PRODUCTS_CATEGORIES', true)
    eventsService
      .getProductsCategories(
        vuexContext.getters.token,
        company,
        vuexContext.getters.appUuid || router.currentRoute.params.appid,
        vuexContext.state.optionsProductsCategories,
        vuexContext.state.searchProductsCategories
      )
      .then(response => {
        vuexContext.commit('SET_TOTAL_PRODUCTS_CATEGORIES', response.productsCategories.count)
        vuexContext.commit('SET_PRODUCTS_CATEGORIES', response.productsCategories.rows)
        vuexContext.commit('SET_LOADING_PRODUCTS_CATEGORIES', false)
      })
      .catch(() => {
        vuexContext.commit('SET_TOTAL_PRODUCTS_CATEGORIES', 0)
        vuexContext.commit('SET_PRODUCTS_CATEGORIES', [])
        vuexContext.commit('SET_LOADING_PRODUCTS_CATEGORIES', false)
      })
  },
  getProductsCategoriesByPlaceId (vuexContext, placeId) {
    const company = vuexContext.getters.companyUuid
    if (!company) {
      return console.log('No company was selected')
    }
    vuexContext.commit('SET_LOADING_PRODUCTS_CATEGORIES', true)
    eventsService
      .getProductsCategoriesByPlaceId(
        vuexContext.getters.token,
        company,
        vuexContext.getters.appUuid || router.currentRoute.params.appid,
        vuexContext.state.optionsProductsCategories,
        vuexContext.state.searchProductsCategories,
        placeId
      )
      .then(response => {
        vuexContext.commit('SET_TOTAL_PRODUCTS_CATEGORIES', response.productsCategories.count)
        vuexContext.commit('SET_PRODUCTS_CATEGORIES', response.productsCategories.rows)
        vuexContext.commit('SET_LOADING_PRODUCTS_CATEGORIES', false)
      })
      .catch(() => {
        vuexContext.commit('SET_TOTAL_PRODUCTS_CATEGORIES', 0)
        vuexContext.commit('SET_PRODUCTS_CATEGORIES', [])
        vuexContext.commit('SET_LOADING_PRODUCTS_CATEGORIES', false)
      })
  },
  async createProductsCategory (vuexContext) {
    try {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCT', true)

      const response = await eventsService.createProductsCategory(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        {
          name: vuexContext.state.newEditProductsCategoryObj.name,
          description: vuexContext.state.newEditProductsCategoryObj.description,
          active: vuexContext.state.newEditProductsCategoryObj.active,
          placeId: vuexContext.state.newEditProductsCategoryObj.placeId
        }
      )
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCT', false)
      if (
        response &&
        response.success &&
        response.productsCategory &&
        response.productsCategory._id
      ) {
        await vuexContext.dispatch('getProductsCategories')
        // set selected productsCategory:
        vuexContext.commit('SET_SELECTED_PRODUCTS_CATEGORY', response.productsCategory)
        // open modal to uplaod products category photos
        vuexContext.commit('SET_SHOW_SET_PRODUCTS_CATEGORY_PHOTO', true)
        return response
      }
      return false
    } catch (error) {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCTS_CATEGORY', false)
      throw error
    }
  },
  async updateProductsCategory (vuexContext) {
    try {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCTS_CATEGORY', true)
      const updateProductsCategoryObj = {
        name: vuexContext.state.newEditProductsCategoryObj.name,
        description: vuexContext.state.newEditProductsCategoryObj.description,
        active: vuexContext.state.newEditProductsCategoryObj.active,
        images: vuexContext.state.newEditProductsCategoryObj.images,
        placeId: vuexContext.state.newEditProductsCategoryObj.placeId
      }
      const productsCategoryId = vuexContext.state.newEditProductsCategoryObj._id
      const response = await eventsService.updateProductsCategory(
        vuexContext.getters.token,
        productsCategoryId,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        updateProductsCategoryObj
      )
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCTS_CATEGORY', false)
      if (response && response.errors) {
        for (let i = 0; i < response.errors.length; i++) {
          await notifications.error(response.errors[i].msg)
        }
      }
      if (response && response.warnings) {
        for (let i = 0; i < response.warnings.length; i++) {
          await notifications.info(response.warnings[i].msg)
        }
      }
      if (response && response.success) {
        await vuexContext.dispatch('getProductsCategories')
        return response
      }
      return false
    } catch (error) {
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCTS_CATEGORY', false)
      throw error
    }
  },
  // upload product's photo
  async uploadProductsCategoryPhoto (vuexContext, { filesForm }) {
    try {
      await vuexContext.commit('SET_UPLOADING_PRODUCTS_CATEGORY_PHOTO', true)
      const response = await eventsService.uploadProductsCategoryPhoto(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.selectedProductsCategory._id,
        { filesForm }
      )
      vuexContext.commit('SET_UPLOADING_PRODUCTS_CATEGORY_PHOTO', false)
      if (response.success) {
        vuexContext.commit('SET_SHOW_SET_PRODUCTS_CATEGORY_PHOTO', false)
        notifications.success('La foto de la categoría del producto fue subida')
        await vuexContext.dispatch('getProductsCategories')
        return true
      } else {
        notifications.error('Sucedió un error al subir foto de la categoría del producto')
      }
    } catch (error) {
      vuexContext.commit('SET_UPLOADING_PRODUCTS_CATEGORY_PHOTO', false)
    }
  },
  // upload product's miniature photo
  async uploadProductsCategoryMiniaturePhoto (vuexContext, { filesForm }) {
    try {
      await vuexContext.commit('SET_UPLOADING_PRODUCTS_CATEGORY_PHOTO', true)
      const response = await eventsService.uploadProductsCategoryMiniaturePhoto(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.selectedProductsCategory._id,
        { filesForm }
      )
      vuexContext.commit('SET_UPLOADING_PRODUCTS_CATEGORY_PHOTO', false)

      if (response.success) {
        vuexContext.commit('SET_SHOW_SET_PRODUCTS_CATEGORY_MINIATURE_PHOTO', false)
        notifications.success('La miniatura de la categoría del producto fue subida')
        await vuexContext.dispatch('getProductsCategories')
        return true
      } else {
        notifications.error('Sucedió un error al miniatura foto de la categoría del producto')
      }
    } catch (error) {
      console.error(error)
      vuexContext.commit('SET_UPLOADING_PRODUCTS_CATEGORY_PHOTO', false)
    }
  },
  async deleteProductsCategory (vuexContext) {
    const company = vuexContext.getters.companyUuid
    const app = vuexContext.getters.appUuid
    const productsCategoryId = vuexContext.state.selectedProductsCategory._id
    const response = await eventsService.deleteProductsCategory(
      vuexContext.getters.token,
      company,
      app,
      productsCategoryId
    )
    return response
  },
  // products:
  getProducts (vuexContext, { placeId, productsCategoryId } = {}) {
    const company = vuexContext.getters.companyUuid
    if (!company) {
      return console.log('No company was selected')
    }
    vuexContext.commit('SET_LOADING_PRODUCTS', true)
    eventsService
      .getProducts(
        vuexContext.getters.token,
        company,
        vuexContext.getters.appUuid || router.currentRoute.params.appid,
        vuexContext.state.optionsProducts,
        vuexContext.state.searchProducts,
        placeId,
        productsCategoryId
      )
      .then(response => {
        vuexContext.commit('SET_TOTAL_PRODUCTS', response.products.count)
        vuexContext.commit('SET_PRODUCTS', response.products.rows)
        vuexContext.commit('SET_LOADING_PRODUCTS', false)
      })
      .catch(() => {
        vuexContext.commit('SET_TOTAL_PRODUCTS', 0)
        vuexContext.commit('SET_PRODUCTS', [])
        vuexContext.commit('SET_LOADING_PRODUCTS', false)
      })
  },
  async createProduct (vuexContext) {
    try {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCT', true)

      const response = await eventsService.createProduct(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        {
          sku: vuexContext.state.newEditProductObj.sku,
          name: vuexContext.state.newEditProductObj.name,
          price: vuexContext.state.newEditProductObj.price,
          description: vuexContext.state.newEditProductObj.description,
          discountPrice: vuexContext.state.newEditProductObj.discountPrice,
          stock: vuexContext.state.newEditProductObj.stock,
          active: vuexContext.state.newEditProductObj.active,
          productsCategories: vuexContext.state.newEditProductObj.productsCategories,
          placeId: vuexContext.state.newEditProductObj.placeId
        }
      )
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCT', false)
      if (
        response &&
        response.success &&
        response.product &&
        response.product.sku
      ) {
        await vuexContext.dispatch('getProducts')
        // set selected product:
        vuexContext.commit('SET_SELECTED_PRODUCT', response.product)
        // open modal to uplaod product photos
        vuexContext.commit('SET_SHOW_SET_PRODUCT_PHOTO', true)
        return response
      }
      return false
    } catch (error) {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCT', false)
      throw error
    }
  },
  async updateProduct (vuexContext) {
    try {
      vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCT', true)
      const updateProductObj = {
        sku: vuexContext.state.newEditProductObj.sku,
        name: vuexContext.state.newEditProductObj.name,
        price: vuexContext.state.newEditProductObj.price,
        description: vuexContext.state.newEditProductObj.description,
        discountPrice: vuexContext.state.newEditProductObj.discountPrice,
        stock: vuexContext.state.newEditProductObj.stock,
        active: vuexContext.state.newEditProductObj.active,
        productsCategories: vuexContext.state.newEditProductObj.productsCategories,
        placeId: vuexContext.state.newEditProductObj.placeId
      }
      const productId = vuexContext.state.newEditProductObj.id
      const response = await eventsService.updateProduct(
        vuexContext.getters.token,
        productId,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        updateProductObj
      )
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCT', false)
      if (response && response.errors) {
        for (let i = 0; i < response.errors.length; i++) {
          await notifications.error(response.errors[i].msg)
        }
      }
      if (response && response.warnings) {
        for (let i = 0; i < response.warnings.length; i++) {
          await notifications.info(response.warnings[i].msg)
        }
      }
      if (response && response.success) {
        await vuexContext.dispatch('getProducts')
        return response
      }
      return false
    } catch (error) {
      await vuexContext.commit('SET_LOADING_SUBMIT_NEW_EDIT_PRODUCT', false)
      throw error
    }
  },
  // upload product's photo
  async uploadProductPhoto (vuexContext, { filesForm }) {
    try {
      await vuexContext.commit('SET_UPLOADING_PRODUCT_PHOTO', true)
      const response = await eventsService.uploadProductPhoto(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.selectedProduct.sku,
        { filesForm }
      )
      vuexContext.commit('SET_UPLOADING_PRODUCT_PHOTO', false)
      if (response.success) {
        vuexContext.commit('SET_SHOW_SET_PRODUCT_PHOTO', false)
        notifications.success('La foto del producto fue subida')
        await vuexContext.dispatch('getProducts')
        return true
      } else {
        notifications.error('Sucedió un error al subir foto del producto')
      }
    } catch (error) {
      vuexContext.commit('SET_UPLOADING_PRODUCT_PHOTO', false)
    }
  },
  // upload product's miniature photo
  async uploadProductMiniaturePhoto (vuexContext, { filesForm }) {
    try {
      await vuexContext.commit('SET_UPLOADING_PRODUCT_PHOTO', true)
      const response = await eventsService.uploadProductMiniaturePhoto(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.selectedProduct.sku,
        { filesForm }
      )
      vuexContext.commit('SET_UPLOADING_PRODUCT_PHOTO', false)

      if (response.success) {
        vuexContext.commit('SET_SHOW_SET_PRODUCT_MINIATURE_PHOTO', false)
        notifications.success('La miniatura del producto fue subida')
        await vuexContext.dispatch('getProducts')
        return true
      } else {
        notifications.error('Sucedió un error al miniatura foto del producto')
      }
    } catch (error) {
      console.error(error)
      vuexContext.commit('SET_UPLOADING_PRODUCT_PHOTO', false)
    }
  },
  async deleteProduct (vuexContext) {
    const company = vuexContext.getters.companyUuid
    const app = vuexContext.getters.appUuid
    const productId = vuexContext.state.selectedProduct.sku
    const response = await eventsService.deleteProduct(
      vuexContext.getters.token,
      company,
      app,
      productId
    )
    return response
  },
  // products purchases:
  getPurchaseProducts (vuexContext) {
    const company = vuexContext.getters.companyUuid
    if (!company) {
      return console.log('No company was selected')
    }
    vuexContext.commit('SET_LOADING_PURCHASE_PRODUCTS', true)
    eventsService
      .getProductsSales(
        vuexContext.getters.token,
        company,
        vuexContext.getters.appUuid || router.currentRoute.params.appid,
        vuexContext.state.optionsPurchaseProducts,
        vuexContext.state.searchPurchaseProducts
      )
      .then(response => {
        vuexContext.commit('SET_LOADING_PURCHASE_PRODUCTS', false)
        if (response && response.purchaseProducts) {
          vuexContext.commit(
            'SET_TOTAL_PURCHASE_PRODUCTS',
            response.purchaseProducts.count
          )
          vuexContext.commit(
            'SET_PURCHASE_PRODUCTS',
            response.purchaseProducts.rows
          )
        }
      })
      .catch(error => {
        console.error(error)

        vuexContext.commit('SET_TOTAL_PURCHASE_PRODUCTS', 0)
        vuexContext.commit('SET_PURCHASE_PRODUCTS', [])
        vuexContext.commit('SET_LOADING_PURCHASE_PRODUCTS', false)
      })
  }
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
